const VARIANT_SUFFIXES: Record<string, string> = {
  'standard packet': 'STD', 'standard': 'STD',
  'small packet': 'SML', 'small': 'SML',
  'large packet': 'LRG', 'large': 'LRG',
  'bulk': 'BLK', 'jumbo': 'JMB', 'mini': 'MINI',
  'sample': 'SMP', 'trial': 'TRL', 'organic': 'ORG',
  'premium': 'PRM', 'economy': 'ECO', 'family pack': 'FAM',
  'wholesale': 'WSL', 'half pound': 'HLB', 'pound': 'LB',
  'ounce': 'OZ', 'quarter pound': 'QLB',
};

export function generateSku(name: string): string {
  return name
    .toUpperCase()
    .replace(/[^A-Z0-9\s]+/g, '')
    .trim()
    .split(/\s+/)
    .map((w) => w.slice(0, 4))
    .slice(0, 3)
    .join('-') || '';
}

export function generateVariantSuffix(
  variantName: string,
  existingSkus: string[]
): string {
  const lower = variantName.toLowerCase().trim();
  if (VARIANT_SUFFIXES[lower]) return VARIANT_SUFFIXES[lower];
  for (const [key, suffix] of Object.entries(VARIANT_SUFFIXES)) {
    if (lower.includes(key)) return suffix;
  }
  const used = existingSkus.map((s) => s.split('-').pop()).filter(Boolean);
  let n = existingSkus.length + 1;
  while (used.includes(`V${n}`)) n++;
  return `V${n}`;
}

export function isAutoGeneratedSku(sku: string, baseSku: string): boolean {
  return sku.startsWith(`${baseSku}-`);
}
